import { BinderEvent } from "@/models/binder.model";
import { CommonModule, DatePipe } from "@angular/common";
import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-activity-column',
    template: `
        <div class="pt-0 pb-0">
              <div *ngIf="value">
                <div class="activity p-0 m-0">{{ latestEvent?.eventName }}</div>
                <div class="p-0 m-0">{{ latestEvent?.eventDate | date:'shortDate' }}</div>
              </div>
        </div>
    `,
    standalone: true,
    imports: [
        DatePipe,
        CommonModule
    ],
    styles: [
        `
        `
    ]
})

export class ActivityColumnComponent {
@Input() value: BinderEvent[] = [];

get latestEvent(): { eventDate: Date, eventName: string } | null {
    if (!this.value || this.value.length === 0) {
      return null;
    }

    // Sort the array by eventDate in descending order
    this.value.sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime());

    // Return the eventDate and eventName of the first item (latest event)
    return {
      eventDate: this.value[0].eventDate,
      eventName: this.value[0].EventTypes.eventName
    };
  }
}